//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//components
import Alerta from '../../../../../util/snackbars/.mixins/';
import Section from '../childrens/Section/.mixins/Section';

//constrollers
import Config from '../../../../../../controllers/config';
import Grupo_controller from '../../../../../../controllers/grupo';
import Log from '../../../../../../controllers/log';

export default class Grupos_ae extends Component {

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            descricao: '',
            tipo: 'Adicionar'
        }
        this.setState = this.setState.bind(this);
        this.validacao = this.validacao.bind(this);

        if (this.props && this.props.params && this.props.params.id) {
            this.state.tipo = 'Editar';
            this.carregarDados();
        }
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:grupos',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-grupos',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela forumulário de grupos!");
    }

    async carregarDados() {

        //instancia cookies e captura user-token para fazer request
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            //recupera dados de grupos
            const r_grupo = await Grupo_controller.getById(token,this.props.params.id);

            //convert dados de grupos para object
            const j_r_grupo = JSON.parse(r_grupo.body);

            //valida resultado da consulta
            if (r_grupo.res.statusCode == 200) {
                var obj = j_r_grupo.itens[0];
                this.setState({descricao: obj.descricao});

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:grupos',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:${obj.descricao}`,
                //     }
                // });
            } else if (j_r_grupo.message === 'Token inválido!') {
                this.child.current.retorno('Autentificação inválida!','error');
                setTimeout(function() {
                    window.location.reload();
                }, 1000);
            } else {
                this.child.current.retorno('Não foi possível carregador os dados!','error');
            }
        } catch (error) {
            this.child.current.retorno('Erro na recuperação de dados de grupo!','error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:grupos',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            var str = "Erro na recuperação de dados de grupo! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    async validacao() {

        if (this.state.descricao === '')
            return this.child.current.retorno('Preencha o campo descrição!','warning');

        var falha = 0
        const cookies = new Cookies();

        //verificar tipo do metodo
        var params = null;
        if (this.state.tipo === 'Adicionar') {
            params = {
                method: 'post',
                url: '/'+this.props.route.title
            }
        } else {
            params = {
                method: 'put',
                url: '/'+this.props.route.title+"/"+this.props.params.id
            }
        }

        var retorno = null

        await fetch(Config.URL_BACKEND+params.url, {
            method: params.method,
            headers: {
                'Content-Type':'application/json',
                'User-Token': cookies.get('User-Token')
            },
            body: JSON.stringify(this.state)
        }).then(function (a) {
            return a.json();
        }).then(function (json) {
            retorno = json;
            if (json.status) {
                falha = 0;
            } else if (json.message === 'Token inválido!') {
                falha = 2;
            } else {
                falha = 1;
            }
        })

        var props = this;
        if (falha === 0) {
            this.child.current.retorno(retorno.message,'success');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:grupos',
            //       eventAction: 'callback',
            //       eventLabel: `sucesso:${retorno.message}`,
            //     }
            // });

            setTimeout(function() {
                props.props.router.goBack();
            }, 1000);
        } else if (falha === 1) {
            const erroString = 'Não foi possível criar um novo '+this.props.route.title+'!';
            this.child.current.retorno(erroString,'error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:grupos',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${erroString}`,
            //     }
            // });
        } else if (falha === 2) {
            this.child.current.retorno('Não foi possível criar um novo '+this.props.route.title+'!','error');
            setTimeout(function() {
                props.props.router.goBack();
            }, 2000);
        }

    }

    render() {
        return (
            <div>
                <Section {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }
}